import React, {useState, useEffect, useRef} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {Panel} from "primereact/panel";
import {Button} from "primereact/button";
import axios from "axios";
import Cookies from "js-cookie";
import moment from "moment";

import HelpComponent from "../HelpComponent";
import {Badge} from "primereact/badge";
import {Tooltip} from "primereact/tooltip";

const _FM_AccommodationpreparationShowComponent = (props) => {

  const {t} = props;
  const navigate = useNavigate();
  const {id, action} = useParams();
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (id) {
      setLoading(true)
      axios({
        method: 'get',
        url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "accommodation-preparation-task-list/" + id,
        params: {},
        headers: {
          'Authorization': 'Bearer ' + Cookies.get("userToken"),
          "Sys-name": Cookies.get("instanceId"),
          "Preferred-locale": Cookies.get("language")
        }
      })
        .then(response => {
          setLoading(false)
          setFormData(response.data.data);
          window.App.setState({rerenderAccommodationpreparationList: false})
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
          setLoading(false)
        })
    }
  }, [window.App.state.rerenderAccommodationpreparationList === true])

  return (
    <>
      <div className={"p-grid p-mt-3"}>
        <div className={"p-col p-col-align-center"}>
          <h2 className={"p-m-0"}>
        {formData.name || t('accommodationpreparation_show')}
          </h2>
        </div>
        <div className={"p-col p-text-right p-col-align-center"}>
          <Button type="button" aria-label={t('edit')}
                  icon={"pi pi-pencil"}
                  onClick={() => {
                    navigate('/accommodation-preparation/update/' + id)
                  }}
                  className="p-button-warning p-ml-2">
          </Button>
          <Button type="button"
                  icon={"pi pi-times"}
                  onClick={() => {
                    navigate(-1)
                  }}
                  className="p-button-secondary close p-ml-2">
          </Button>
        </div>
      </div>
      <div className={"p-grid"}>
        <div className={"p-col"}>
          <small className={"p-text-uppercase"}>
            {t('created_at')}
          </small>
          <p className={"p-mt-0 p-mb-0 p-text-bold"}>
            {moment.utc(formData.created_at_snapshot).local().format(t('YYYY-MM-DD HH:mm:ss'))}
          </p>
        </div>
        <div className={"p-col"}>
          <small className={"p-text-uppercase"}>
            {t('updated_at')}
          </small>
          <p className={"p-mt-0 p-mb-0 p-text-bold"}>
            {moment.utc(formData.updated_at_snapshot).local().format(t('YYYY-MM-DD HH:mm:ss'))}
          </p>
        </div>
      </div>
      <Panel className={"p-mt-3"}>
        {/*<HelpComponent type={"site"} position={"IN_ACTIVE_BOX"}/>*/}
        <HelpComponent type={"show_box"}/>
        <div className={"p-grid"}>
          <div className={"p-col-12 p-lg-6"}>
            <div className="p-field p-fluid">
              <label htmlFor="residential_unit">{t('residential_unit')}</label>
              <span className="p-d-block p-text-bold">
                {formData?.residential_unit?.name}
                {/*{formData?.residential_unit?.is_ready === true ? (*/}
                {/*  <Badge severity="success" style={{height: '8px', width: '8px', minWidth: '8px', position: 'relative', top: '-5px', left: '5px'}}></Badge>*/}
                {/*) : (*/}
                {/*  <Badge severity="danger"  style={{height: '8px', width: '8px', minWidth: '8px', position: 'relative', top: '-5px', left: '5px'}}></Badge>*/}
                {/*)}*/}
              </span>
            </div>
            <div className="p-field p-fluid">
              <label htmlFor="reservation">{t('reservation')}</label>
              <span className="p-d-block p-text-bold">
                {formData?.reservation?.association_code &&
                  <>
                    <span className={"tt-association-code-accommodation-show-info-" + formData?.reservation?.id + " p-mr-2"}
                          data-pr-tooltip={formData?.reservation?.association_code}>
                      <i className={"pi pi-info-circle"} style={{fontSize: '0.85rem', color: '#6c757d', cursor: 'pointer'}}></i>
                    </span>
                    <Tooltip target={".tt-association-code-accommodation-show-info-" + formData?.reservation?.id}/>
                    <span className={"p-badge"}
                          style={{
                            fontSize: '1rem',
                            backgroundColor: formData?.reservation?.status
                              ? formData?.reservation?.status?.toLowerCase() === 'pending'
                                ? '#dddddd'
                                : formData?.reservation?.status?.toLowerCase() === 'confirmed'
                                  ? '#f1eea5'
                                  : formData?.reservation?.status?.toLowerCase() === 'cancelled'
                                    ? '#f7a2a2'
                                    : formData?.reservation?.status?.toLowerCase() === 'checked_in'
                                      ? '#3ec0e9'
                                      : formData?.reservation?.status?.toLowerCase() === 'checked_out'
                                        ? '#0abb87'
                                        : formData?.reservation?.status?.toLowerCase() === 'no_show'
                                          ? '#8a2be2'
                                          : '#ccc'
                              : undefined,
                            color: formData?.reservation?.status
                              ? formData?.reservation?.status?.toLowerCase() === 'pending' || formData?.reservation?.status?.toLowerCase() === 'confirmed'
                                ? '#5f656b'
                                : formData?.reservation?.status?.toLowerCase() === 'no_show'
                                  ? '#fff'
                                  : undefined
                              : undefined
                    }}>
                      {formData?.reservation?.association_code?.split(' | ').pop()?.trim()}
                    </span>
                  </>
                }
              </span>
            </div>
          </div>
          <div className={"p-col-12 p-lg-6"}>
            <div className="p-field p-fluid">
              <label htmlFor="tasks">{t('tasks')}</label>
              <span className="p-d-block">
                    {formData.tasks && formData.tasks[0] &&
                      <ul className={"p-ml-0 p-mt-0 p-pl-0"} style={{listStyle: 'none'}}>
                        {formData.tasks.map((task, index) => {
                          return (
                            <li>
                              {task.is_done ? (
                                <i className={"pi pi-check text-success"} style={{position: 'relative', bottom: '-1px'}}></i>
                              ) : (
                                <i className={"pi pi-times text-danger"} style={{position: 'relative', bottom: '-1px'}}></i>
                              )}
                              &nbsp;
                              {task.name}
                            </li>
                          )
                        })}
                      </ul>
                    }
              </span>
            </div>
          </div>
        </div>
      </Panel>
    </>
  )
}
export default withTranslation('common')(_FM_AccommodationpreparationShowComponent);
